import ProfileIcon from '../img/profile_menu_gray.svg'
import Header from './Header'
import { useIntl } from 'react-intl'
import { TranslationsService } from '../services/index'

const ProfileMenu = ({ userDetails }) => {
  let user = userDetails.userData
  const { formatMessage } = useIntl()

  return (
    <>
      <Header />
      <div className="bg-green flex flex-col items-center pt-10 pb-8">
        {user && (
          <>
            <figure>
              <img
                src={`${
                  user.profilePicture
                    ? `${process.env.RAZZLE_API_URL}/${user.profilePicture.url}`
                    : ProfileIcon
                }`}
                alt="Profile icon"
                width="183"
                height="auto"
                className="w-16 h-16 border-4 border-orange rounded-full"
              />
            </figure>
            <h2 className="text-white text-2xl font-semibold">
              {user.firstName + ' ' + user.familyName}
            </h2>
            <h3 className="text-white text-lg">
              {formatMessage({ id: 'municipality' })}{' '}
              {user.municipality
                ? TranslationsService.getLanguage() === 'mk'
                  ? user.municipality.name
                  : user.municipality.name_sq
                : ''}
            </h3>
            <div className="flex items-center justify-center space-x-5 flex-wrap mt-5">
              {user.interests.map((item) => (
                <div
                  key={item.id}
                  className="w-auto inline-flex items-center justify-center border-2 border-white text-sm md:text-base font-semibold rounded-full text-white bg-transparent hover:bg-opacity-80 py-1.5 px-5 mb-4"
                >
                  {TranslationsService.getLanguage() === 'mk'
                    ? item.name
                    : item.name_sq}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default ProfileMenu
